import {CompetitionOddsPageRouteMetaDataModel} from "./competition-odds-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionOddsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.odds,
      path: `odds`,
      componentImport: () => import("../components/competition-odds-page" /* webpackChunkName: "competition-odds-page" */ ),
      metadataType: CompetitionOddsPageRouteMetaDataModel
    });
  }
}
